var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckboxEmpty = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8158_389)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21429 1.66367C2.3464 1.66367 1.64286 2.3672 1.64286 3.2351V11.8065C1.64286 12.6744 2.3464 13.378 3.21429 13.378H11.7857C12.6536 13.378 13.3571 12.6744 13.3571 11.8065V3.2351C13.3571 2.36719 12.6536 1.66367 11.7857 1.66367H3.21429ZM0.5 3.2351C0.5 1.736 1.71523 0.520813 3.21429 0.520813H11.7857C13.2848 0.520813 14.5 1.73601 14.5 3.2351V11.8065C14.5 13.3056 13.2848 14.5208 11.7857 14.5208H3.21429C1.71523 14.5208 0.5 13.3056 0.5 11.8065V3.2351Z",
    fill: "#5849A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8158_389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.020813)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckboxEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkbox-empty.78309723.svg";
export { ForwardRef as ReactComponent };